import { render, staticRenderFns } from "./CustomerRecognition.vue?vue&type=template&id=e0e1f908&scoped=true&"
import script from "./CustomerRecognition.vue?vue&type=script&lang=js&"
export * from "./CustomerRecognition.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRecognition.vue?vue&type=style&index=0&id=e0e1f908&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e1f908",
  null
  
)

export default component.exports